import IconAdd from "@/assets/images/icon-add.svg?react";
import styled from "@emotion/styled";

export const IconAddStyle = styled(IconAdd)`
  & path {
    fill: #3548c9;
  }
`;

export const Root = styled.form`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  & .theme-table-container {
    overflow-y: unset !important;
  }
  & .card-filter {
    margin: 24px 0;
    .theme-card-body {
      display: flex;
      gap: 12px;
      & > div:first-of-type {
        width: 20%;
      }
      & > div:last-child {
        width: 80%;
      }
    }
  }
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
`;

export const TextCampaignsId = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #3548c9;
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;
